import React from 'react';
import { LineChart as RechartsLineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
const data = [{
  name: 'Ene',
  value: 4000,
  target: 2400
}, {
  name: 'Feb',
  value: 3000,
  target: 2400
}, {
  name: 'Mar',
  value: 2000,
  target: 2400
}, {
  name: 'Abr',
  value: 2780,
  target: 2400
}, {
  name: 'May',
  value: 1890,
  target: 2400
}, {
  name: 'Jun',
  value: 2390,
  target: 2400
}];
export const LineChart = () => {
  return <div className="h-[400px] w-full" data-id="element-302">
      <ResponsiveContainer width="100%" height="100%" data-id="element-303">
        <RechartsLineChart data={data} margin={{
        top: 20,
        right: 30,
        left: 20,
        bottom: 5
      }} data-id="element-304">
          <CartesianGrid strokeDasharray="3 3" data-id="element-305" />
          <XAxis dataKey="name" data-id="element-306" />
          <YAxis data-id="element-307" />
          <Tooltip data-id="element-308" />
          <Line type="monotone" dataKey="value" stroke="#3B82F6" strokeWidth={2} data-id="element-309" />
          <Line type="monotone" dataKey="target" stroke="#E11D48" strokeWidth={2} strokeDasharray="5 5" data-id="element-310" />
        </RechartsLineChart>
      </ResponsiveContainer>
    </div>;
};